import React from "react";

const imgPlaceholder =
    `<svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="96" height="96" fill="#888888" fill-opacity="0.1"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="m 31.125,37.96875 c 0,-1.553344 1.259156,-2.8125 2.8125,-2.8125 h 28.125 c 1.553344,0 2.8125,1.259156 2.8125,2.8125 v 20.0625 c 0,1.553344 -1.259156,2.8125 -2.8125,2.8125 h -28.125 c -1.553344,0 -2.8125,-1.259156 -2.8125,-2.8125 z m 11.25,4.6875 c 0,2.071031 -1.678969,3.75 -3.75,3.75 -2.071031,0 -3.75,-1.678969 -3.75,-3.75 0,-2.071031 1.678969,-3.75 3.75,-3.75 2.071031,0 3.75,1.678969 3.75,3.75 z m -5.53125,13.5 h 22.265625 c 0.621281,0 1.125,-0.503719 1.125,-1.125 v -5.440219 c 0,-0.298406 -0.1185,-0.584531 -0.329531,-0.795562 l -5.0625,-5.0625 c -0.439313,-0.439313 -1.151625,-0.439313 -1.590938,0 l -7.549687,7.549687 c -0.439313,0.439313 -1.151625,0.439313 -1.590938,0 l -2.487187,-2.487187 c -0.439313,-0.439313 -1.151625,-0.439313 -1.590938,0 l -3.984375,3.984375 C 35.83725,52.990875 35.71875,53.277 35.71875,53.575406 v 1.455844 c 0,0.621281 0.503719,1.125 1.125,1.125 z" fill="#888888" fill-opacity="0.2"/>
    </svg>`
;

export type ImagePlaceholderProps = {
    className?: string;
};

export const ImagePlaceholder: React.FC<ImagePlaceholderProps> = ({
    className
}) => {
    return (
        <img
            aria-hidden={true}
            src={`data:image/svg+xml;utf8,${encodeURIComponent(imgPlaceholder)}`}
            className={className}
            loading="lazy"
            alt={""}
        />
    );
}
